{
  "export-issues-flyout-spotlight-tour.spotlight.body": [
    {
      "type": 0,
      "value": "Export your work items in the format you need, right from the more actions menu."
    }
  ],
  "export-issues-flyout-spotlight-tour.spotlight.heading": [
    {
      "type": 0,
      "value": "Export options have moved"
    }
  ],
  "export-issues-flyout-spotlight-tour.spotlight.okButton": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.backButton": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.step1Body": [
    {
      "type": 0,
      "value": "Add the fields you need and remove the fields you don’t."
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.step1Headline": [
    {
      "type": 0,
      "value": "Add and remove fields"
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.step2Body": [
    {
      "type": 0,
      "value": "Reorder and pin fields to prioritize what matters most to you."
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.step2Headline": [
    {
      "type": 0,
      "value": "Reorder and pin fields"
    }
  ],
  "jira-filter-refinement-board-and-backlog.tour.stepIndicator": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "jira-filter-refinement.tour.backButton": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jira-filter-refinement.tour.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-filter-refinement.tour.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-filter-refinement.tour.step1Body": [
    {
      "type": 0,
      "value": "Save any filter combination to reuse later."
    }
  ],
  "jira-filter-refinement.tour.step1Headline": [
    {
      "type": 0,
      "value": "Save your filter"
    }
  ],
  "jira-filter-refinement.tour.step2Body": [
    {
      "type": 0,
      "value": "Add the fields you need and remove the fields you don’t."
    }
  ],
  "jira-filter-refinement.tour.step2Headline": [
    {
      "type": 0,
      "value": "Add and remove fields"
    }
  ],
  "jira-filter-refinement.tour.step3Body": [
    {
      "type": 0,
      "value": "Reorder and pin fields to prioritize what matters most to you."
    }
  ],
  "jira-filter-refinement.tour.step3Headline": [
    {
      "type": 0,
      "value": "Reorder and pin fields"
    }
  ],
  "jira-filter-refinement.tour.stepIndicator": [
    {
      "type": 1,
      "value": "currentStep"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "jira-nin-issue-preview-panel-resize.body": [
    {
      "type": 0,
      "value": "Drag to resize the panel and view more work item information."
    }
  ],
  "jira-nin-issue-preview-panel-resize.heading": [
    {
      "type": 0,
      "value": "Expand the panel"
    }
  ],
  "jira-nin-issue-preview-panel.body": [
    {
      "type": 0,
      "value": "View and edit work items in the new preview panel, while staying on the List."
    }
  ],
  "jira-nin-issue-preview-panel.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-issue-preview-panel.heading": [
    {
      "type": 0,
      "value": "Access work items instantly"
    }
  ],
  "jira-nin-issue-preview-panel.more": [
    {
      "type": 0,
      "value": "More about preview panels"
    }
  ],
  "jira-nin-issue-preview-panel.new-window": [
    {
      "type": 0,
      "value": "(opens in a new window)"
    }
  ],
  "jira-nin-issue-preview-panel.tour.arrows-heading": [
    {
      "type": 0,
      "value": "Preview your work items"
    }
  ],
  "jira-nin-issue-preview-panel.tour.arrows-image-alt": [
    {
      "type": 0,
      "value": "Navigation arrows on the glance panel"
    }
  ],
  "jira-nin-issue-preview-panel.tour.arrows-modal-body": [
    {
      "type": 0,
      "value": "Select the arrows to move through work items. Select minimise to view your work in a preview panel."
    }
  ],
  "jira-nin-issue-preview-panel.tour.arrows-panel-body": [
    {
      "type": 0,
      "value": "Select the arrows to move through work items. Select expand for modal view."
    }
  ],
  "jira-nin-issue-preview-panel.tour.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jira-nin-issue-preview-panel.tour.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-issue-preview-panel.tour.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-nin-issue-preview-panel.tour.intro-body": [
    {
      "type": 0,
      "value": "View work item details in a layout that works best for your list."
    }
  ],
  "jira-nin-issue-preview-panel.tour.intro-heading": [
    {
      "type": 0,
      "value": "New ways to view work in context"
    }
  ],
  "jira-nin-issue-preview-panel.tour.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-issue-preview-panel.tour.resize-body": [
    {
      "type": 0,
      "value": "Drag to resize the panel and view more work item information."
    }
  ],
  "jira-nin-issue-preview-panel.tour.resize-heading": [
    {
      "type": 0,
      "value": "Expand the panel"
    }
  ],
  "jira-nin-issue-preview-panel.tour.step-count": [
    {
      "type": 1,
      "value": "current"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription": [
    {
      "type": 0,
      "value": "Want us to apply your current filter and group settings to this new List view?"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo": [
    {
      "type": 0,
      "value": "No"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes": [
    {
      "type": 0,
      "value": "Yes"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.description": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. A new List view."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription": [
    {
      "type": 0,
      "value": "Any existing filters and groups will be applied."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.learnMoreLink": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.body": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. A new List view."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label": [
    {
      "type": 0,
      "value": "Explore List view"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.filter": [
    {
      "type": 0,
      "value": "One place to search work and filter results to find what you need."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions": [
    {
      "type": 0,
      "value": "Dive deeper - view work items as a chart, use format rules to highlight key work, and more."
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.body": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience."
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more": [
    {
      "type": 0,
      "value": "Tell me more"
    }
  ],
  "jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.description.filter": [
    {
      "type": 0,
      "value": "You can now filter work items by status and priority, making it easier to find work."
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.description.improvements": [
    {
      "type": 0,
      "value": "More improvements to come."
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.description.parent": [
    {
      "type": 0,
      "value": "Use the parent filter to search for epics, as well as any other work items with child work items."
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.page2.title": [
    {
      "type": 0,
      "value": "We've updated epic to parent"
    }
  ],
  "jira.filter.refinement.filter-popup.changeboarding.title": [
    {
      "type": 0,
      "value": "Introducing a new home for filters"
    }
  ]
}